import { MembreRelation } from './MembreRelation.class';
/**
 * Chaque objet est un lien unissant deux membres
 */
export class Blocage extends MembreRelation {
    /**
     * Constructeur de l'objet Blocage
     * @param contact contient les données de l'objet
     */
    constructor(bloqueObject) {
        if (bloqueObject) {
            const { idBlocage, bloqueur, bloque, dateBlocage } = bloqueObject;
            super({
                idRelation: idBlocage,
                idExpediteur: bloqueur,
                idRecepteur: bloque,
            });
            this.dateBlocage = dateBlocage;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmxvY2FnZS5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkJsb2NhZ2UuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLHdCQUF3QixDQUFDO0FBRXhEOztHQUVHO0FBQ0gsTUFBTSxPQUFPLE9BQVEsU0FBUSxjQUFjO0lBcUIxQzs7O09BR0c7SUFDSCxZQUFtQixZQUErQjtRQUNqRCxJQUFJLFlBQVksRUFBRTtZQUNqQixNQUFNLEVBQUUsU0FBUyxFQUFFLFFBQVEsRUFBRSxNQUFNLEVBQUUsV0FBVyxFQUFFLEdBQUcsWUFBWSxDQUFDO1lBRWxFLEtBQUssQ0FBQztnQkFDTCxVQUFVLEVBQUUsU0FBUztnQkFDckIsWUFBWSxFQUFFLFFBQVE7Z0JBQ3RCLFdBQVcsRUFBRSxNQUFNO2FBQ25CLENBQUMsQ0FBQztZQUVILElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFDO1NBQy9CO0lBQ0YsQ0FBQztDQUtEIn0=